// removed by extract-text-webpack-plugin
module.exports = {"summary":"SubjectPage__summary___3ur5p","headerContainer":"SubjectPage__headerContainer___19Ggo","goBackButton":"SubjectPage__goBackButton___1ybCG"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/pages/SubjectPage.css
// module id = 1222
// module chunks = 0